<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Amount">
            <div style="position: relative">
              <AmountSelector />
              <ErrorLabel field="amount" style="text-align: right" />
            </div>
          </FormSection>
          <FormSection v-if="form.amount">
            <TransactionFee />
          </FormSection>
          <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addMonthly addSplit monthesSelector/>
            </div>
          </FormSection>
          <FormSection title="Donation Designation">
            <NcsyAlumniDesignation />
          </FormSection>
          <FormSection>
            <InHonorOf />
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
          </FormSection>
          <FormSection title="I'm currently an">
            <FormRow inline>
              <FormSelect
                field="custom.current"
                class="width-half"
                style="margin-right: 10px"
              >
                <option value="" disabled selected hidden>Select Option</option>
                <option selected="selected" value="NCSY Alumnus">NCSY Alumnus</option>
                <option value="NCSYer">NCSYer</option>
                <option value="NCSY Advisor">NCSY Advisor</option>
                <option value="NCSY Parent">NCSY Parent</option>
                <option value="NCSY Supporter">NCSY Supporter</option>
                <option value="Other">Other</option>
              </FormSelect>
              <FormInput
                class="width-half"
                field="custom.currentOther"
                v-if="getValue('custom.current') == 'Other'"
              />
            </FormRow>
          </FormSection>
          <FormSection title="I'd like information about">
            <FormRow inline>
              <FormSelect field="custom.information" class="width-half">
                <option value="" disabled selected hidden>Select Information</option>
                <option selected="selected" value="Program for my kids or grandkids">
                  Program for my kids or grandkids
                </option>
                <option value="Summer Programs">Summer Programs</option>
                <option value="Birthright Israel">Birthright Israel</option>
                <option value="Leaving a legacy to NCSY">Leaving a legacy to NCSY</option>
                <option
                  value="Learning with a NCSY'er in college once per week by phone/online"
                >
                  Learning with a NCSY'er in college once per week by phone/online
                </option>
                <option value="No thanks">No thanks</option>
              </FormSelect>
            </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate Now" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { setValue, form, getValue } = usePaymentForm();

    return {
      form,
      getValue,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep h2 {
  color: #1aa8d3;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
}

::v-deep .form-container.ou-donation-form {
  max-width: 100%;
}
::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label {
  background: #1aa8d3;
}
::v-deep hr {
  background: none;
  box-shadow: none;
  height: 0;
  border: none;
  margin-bottom: 20px;
  border-bottom: 1px solid #efefef;
}
::v-deep .monthly-note {
  color: black;
}

::v-deep span.flex > span {
    display: flex;
}
</style>
